import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// Import CSS here
import "./assets/scss/index.scss";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
